import { toast } from "sonner";
import { DealerRequestModel } from "../../domain/models/dealerModel";
import { DropResult } from "@hello-pangea/dnd";
import { RouteModel } from "../../domain/models/routeModel";

export default function RemoveSlipFromRoute(
  routes: RouteModel[],
  dealers: DealerRequestModel[],
  dropResult: DropResult,
): { routes: RouteModel[]; dealers: DealerRequestModel[] } {
  if (!dropResult.destination) {
    return {
      routes,
      dealers,
    };
  }

  // Get the draggable element.
  const draggable = dropResult.draggableId;
  const slipId = draggable.replace("slip:", "");

  const packingSlip = routes
    .flatMap((r) => r.packingSlips)
    .find((slip) => slip.id === slipId);

  if (!packingSlip) {
    toast.error("Could not find packing slip:" + slipId + " to move");
    return {
      routes,
      dealers,
    };
  }
  routes = routes.map((route) => {
    //Remove slip from old route.
    if (route.packingSlips.some((slip) => slip.id === packingSlip.id)) {
      route.packingSlips = route.packingSlips.filter(
        (slip) => slip.id !== packingSlip.id,
      );
    }
    return route;
  });

  // Add the request back to the dealers
  const existingDealer = dealers.find(
    (d) => d.relation.id === packingSlip.relation.id,
  );
  const deliverRequests = packingSlip.requests.filter(
    (request) => request.type === "deliver",
  );
  if (existingDealer) {
    existingDealer.deliver_requests.push(...deliverRequests);
    existingDealer.pickup_amount =
      (packingSlip.pickup_amount ?? 0) + (existingDealer.pickup_amount ?? 0);
  } else {
    dealers.push({
      relation: packingSlip.relation,
      deliver_requests: deliverRequests,
      pickup_amount: packingSlip.pickup_amount ?? 0,
    });
  }
  return {
    routes,
    dealers,
  };
}
